/*
 * Copyright (c) 2023. iSecNew10 Enterprises LLC
 */

const Validator = {
    isEmpty: (value: any) => {
        return typeof value === 'undefined' || value === null ||
            (
                (
                    typeof value === 'string'
                    || Array.isArray(value)
                )
                && value.length < 1
            )
    },
    isEmail: (value: string) => {
        return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
    }
}

export default Validator
